const Footer = () => {
  return (
    <footer className="footer py-4">
      <div className="container-fluid">
     
      </div>
    </footer>
  );
};

export default Footer;
